import { Timestamp } from '@angular/fire/firestore';

export type StickyNoteVisibility = 'personal' | 'team';
export type StickyNoteAccent = 'amber' | 'violet' | 'cyan' | 'emerald' | 'rose';
export type StickyBoardStyle = 'paper' | 'board';

export interface LoadStickyNote {
  id: string;
  companyId: string;
  loadId: string;
  /** `null` or `undefined` = load-level note; `1..N` = anchored to a specific stop. */
  stopNumber?: number | null;
  visibility: StickyNoteVisibility;
  color: StickyNoteAccent;
  content: string;
  pinned: boolean;
  authorId: string;
  authorName: string;
  createdAt?: Timestamp | number | null;
  updatedAt?: Timestamp | number | null;
}

export const STICKY_ACCENT_OPTIONS: ReadonlyArray<{
  value: StickyNoteAccent;
  label: string;
}> = [
  { value: 'amber', label: 'Amber' },
  { value: 'violet', label: 'Violet' },
  { value: 'cyan', label: 'Cyan' },
  { value: 'emerald', label: 'Emerald' },
  { value: 'rose', label: 'Rose' },
];
